// objectif-tab.component.ts
import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-objectif-tab',
  templateUrl: './objectif-tab.component.html'
})
export class ObjectifTabComponent {
  @Input() title: string;
  @Input() objectifs: any[];
  @Input() typeVisualisation: string;
  @Output() add = new EventEmitter<void>();
  @Output() save = new EventEmitter<void>();
  @Output() delete = new EventEmitter<number>();

  get isEvaluationMode(): boolean {
    return this.typeVisualisation === 'evaluation';
  }

  onAdd() {
    this.add.emit();
  }

  onDelete(index: number) {
    this.delete.emit(index);
  }

  onSave() {
    this.save.emit();
  }
}
